import {Product} from '../product';
import {cycleMonths, findBestPrice, UpsellBillingCycle} from './find-best-price';
import {memo} from 'react';
import {Trans} from '@ui/i18n/trans';

interface UpsellLabelProps {
  products?: Product[];
  cycle?: UpsellBillingCycle;
}
export const UpsellLabel = memo(({products, cycle = 'yearly'}: UpsellLabelProps) => {
  const upsellPercentage = calcSavingsPercentage(products, cycle);

  if (upsellPercentage <= 0) {
    return null;
  }

  return (
    <span className="text-xs font-medium text-positive-darker">
      <Trans
        message="Save up to :percentage%"
        values={{percentage: upsellPercentage}}
      />
    </span>
  );
});

function calcSavingsPercentage(
  products?: Product[],
  cycle: UpsellBillingCycle = 'yearly',
): number {
  if (!products?.length || cycle === 'monthly') return 0;

  const months = cycleMonths[cycle];

  const decreases = products.map(product => {
    if (product.hidden) return 0;

    const monthly    = findBestPrice('monthly', product.prices);
    const cyclePrice = findBestPrice(cycle, product.prices);

    if (!monthly || !cyclePrice) return 0;

    const monthlyTotal = monthly.amount * months;
    const saving = Math.round(
      ((monthlyTotal - cyclePrice.amount) / monthlyTotal) * 100,
    );

    return saving > 0 && saving <= 200 ? saving : 0;
  });

  return Math.max(0, ...decreases);
}
